import { z } from 'zod';

export const $CandidateFileType = z.object({
  value: z.string(),
  name: z.string(),
});
